import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import WizardInput from 'components/wizard/WizardInput';
import FalconDropzone from 'components/common/FalconDropzone';
import avatarImg from 'assets/img/products/product-placeholder11.png';
import { isIterableArray } from 'helpers/utils';
import Avatar from 'components/common/Avatar';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import Flex from 'components/common/Flex';
import { Col, Row } from 'react-bootstrap';
import { useAuthWizardContext } from 'providers/AuthWizardProvider';
import CreatableSelect from 'react-select/creatable';
import { getCategories, getMarques } from 'data/produits';

const InformationsSupplementaires = ({ register, errors, setValue }) => {
  const [optionsCategories, setOptionsCategories] = useState();
  const [optionsMarques, setOptionsMarques] = useState();
  const { user } = useAuthWizardContext();
  const [avatar, setAvatar] = useState([
    ...(user.avater ? user.avater : []),
    { src: avatarImg }
  ]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        // Execute both API calls concurrently
        const [categoriesResponse, marquesResponse] = await Promise.all([
          getCategories(), // API call to fetch categories
          getMarques() // API call to fetch marques
        ]);
        console.log('Categories:', categoriesResponse);
        console.log('Marques:', marquesResponse);
        const defaultCategory = {
          value: 'Catégorie générale',
          label: 'Catégorie générale'
        };
        const defaultMarque = {
          value: 'Marque générale',
          label: 'Marque générale'
        };

        // Map categoriesResponse to the correct format
        setOptionsCategories([
          defaultCategory,
          ...categoriesResponse.map(categorie => ({
            value: categorie.categorie, // Use the correct key from the API response
            label: categorie.categorie // Use the correct key from the API response
          }))
        ]);

        // Map marquesResponse to the correct format
        setOptionsMarques([
          defaultMarque,
          ...marquesResponse.map(marque => ({
            value: marque.marque, // Use the correct key from the API response
            label: marque.marque // Use the correct key from the API response
          }))
        ]);

        setValue('categorie', defaultCategory.value);
        setValue('marque', defaultMarque.value);
      } catch (error) {
        console.error('Error fetching categories or marques:', error);
      }
    };

    fetchOptions();
  }, []);

  return (
    <>
      <Row className="mb-3">
        <Col md="auto">
          <Avatar
            size="4xl"
            src={
              isIterableArray(avatar) ? avatar[0]?.base64 || avatar[0]?.src : ''
            }
          />
        </Col>
        <Col md>
          <FalconDropzone
            files={avatar}
            onChange={files => {
              setAvatar(files);
              setValue('avatar', files);
            }}
            multiple={false}
            accept="image/*"
            placeholder={
              <>
                <Flex justifyContent="center">
                  <img src={cloudUpload} alt="" width={25} className="me-2" />
                  <p className="fs-9 mb-0 text-700">Upload image produit</p>
                </Flex>
                <p className="mb-0 w-75 mx-auto text-400">
                  Upload a 300x300 jpg image with a maximum size of 400KB
                </p>
              </>
            }
          />
        </Col>
      </Row>
      <label className="mb-1">Marque</label>
      <CreatableSelect
        isClearable
        options={optionsMarques}
        placeholder="Sélectionner une marque"
        className="w-100"
        onChange={selectedOption => {
          if (selectedOption) {
            console.log('Selected value:', selectedOption.value); // Logs the selected value
            setValue('marque', selectedOption.value); // Updates the value in react-hook-form
          } else {
            console.log('Selection cleared');
            setValue('marque', ''); // Clears the value in react-hook-form
          }
        }}
      />
      <label className="mb-1 mt-3">Catégorie</label>
      <CreatableSelect
        isClearable
        options={optionsCategories}
        placeholder="Sélectionner une catégorie"
        className="w-100"
        onChange={selectedOption => {
          if (selectedOption) {
            console.log('Selected value:', selectedOption.value); // Logs the selected value
            setValue('categorie', selectedOption.value); // Updates the value in react-hook-form
          } else {
            console.log('Selection cleared');
            setValue('categorie', ''); // Clears the value in react-hook-form
          }
        }}
      />
      <WizardInput
        label="Référence produit"
        name="reference"
        errors={errors}
        formGroupProps={{ className: 'mb-3 mt-3' }}
        formControlProps={{
          ...register('refProduit')
        }}
      />

      <WizardInput
        label="Référence fabricant"
        name="reference"
        errors={errors}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('refFournisseur')
        }}
      />

      <WizardInput
        label="Code barres"
        name="cab"
        errors={errors}
        formGroupProps={{ className: 'mb-3' }}
        formControlProps={{
          ...register('cab')
        }}
      />

      <WizardInput
        type="textarea"
        label="Description"
        name="Description"
        errors={errors}
        formGroupProps={{
          className: 'mb-3'
        }}
        formControlProps={{
          className: 'input-spin-none',
          style: { height: '10px' },
          ...register('description')
        }}
      />
    </>
  );
};

InformationsSupplementaires.propTypes = {
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setValue: PropTypes.func.isRequired
};

export default InformationsSupplementaires;
